module.exports = __webpack_public_path__ + "static/media/confcp_120.d86fad09.ico";